import { IconButton, Tabs, Tab } from "@mui/material";
import { styled } from "@mui/material/styles";
import { orange } from "@mui/material/colors";
import type { HTMLAttributes, ReactNode } from "react";

// IconButton with border
export const RpGridListButton = styled(IconButton)(({ theme }) => ({
  border: `1px solid ${theme?.palette?.primary?.main}`,
  borderRadius: "var(--radius-control)",
}));

// IconButton Orange
export const RpGridListButtonOrange = styled(IconButton)(() => ({
  border: `1px solid ${orange[400]}`,
  backgroundColor: orange[400],
  color: "var(--neutral-white)",
  borderRadius: "var(--radius-control)",
}));

// Tabs switcher
export const RpSwitchTabs = styled(Tabs)(() => ({
  minWidth: "auto",
  minHeight: "auto",
  width: "auto",
  background: "var(--neutral-white)",
  borderRadius: "var(--radius-round)",
  "& .MuiTabs-indicator": {
    display: "none",
  },
}));

// Individual Tab
export const RpSwitchTab = styled(Tab)(({ theme }) => ({
  borderRadius: "var(--radius-round)",
  minWidth: "auto",
  minHeight: "auto",
  background: theme?.palette?.primary?.contrastText,
  color: theme?.palette?.primary?.main,
  margin: "0",
  padding: "2px 16px",
  fontSize: 14,
  fontWeight: 600,
  textTransform: "none",
  opacity: 1,
  "&.Mui-selected": {
    background: theme?.palette?.primary?.main,
    color: theme?.palette?.primary?.contrastText,
  },
}));

// TabPanel
interface TabPanelProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  index: number | string;
  value: number | string;
}

export function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`campaigns-tabpanel-${index}`}
      aria-labelledby={`campaigns-tab-${index}`}
      {...other}
      className="rp-campaign-tab"
    >
      {children}
    </div>
  );
}
